<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          v-if="permission('read', 'resident_medical_prescription')"
          @click="handleStep('PRESCRICAO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'PRESCRICAO' && 'active',
          ]"
          id="nav-prescricao"
          data-toggle="tab"
          href="#prescricao"
          role="tab"
          aria-controls="prescricao"
          aria-selected="true"
          >PRESCRIÇÃO</a
        >

        <a
          v-if="permission('read', 'resident_medical_prescription')"
          @click="handleStep('HORARIO')"
          :class="['nav-link link-nav-resident', step == 'HORARIO' && 'active']"
          id="nav-receita"
          data-toggle="tab"
          href="#horario"
          role="tab"
          aria-controls="horario"
          aria-selected="false"
          >HORÁRIOS</a
        >
      </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="
          permission('read', 'resident_medical_prescription') &&
          step == 'PRESCRICAO'
        "
        :class="['tab-pane fade', step == 'PRESCRICAO' && 'show active']"
        id="prescricao"
        role="tabpanel"
        aria-labelledby="nav-prescricao"
      >
        <div class="contracts-modern">
          <div class="contracts-header">
            <div class="header-content">
              <div class="title-section">
                <h2 class="section-title">
                  <i class="fas fa-hands-helping title-icon"></i>
                  Cuidados
                </h2>

                <p class="section-subtitle">
                  Registre os cuidados do residente
                </p>
              </div>

              <div class="actions-section">
                <v-btn
                  class="btn-add-modern"
                  @click="$bvModal.show('care-created')"
                >
                  <i class="fas fa-plus mr-2"></i>
                  Novo Cuidado
                </v-btn>
              </div>
            </div>
          </div>

          <div class="contract-content">
            <div class="info-card">
              <CareView ref="careView" :resident_id="resident_id" />
            </div>
          </div>

          <CareCreated @create="refresh" :resident_id="resident_id" />
        </div>
      </div>

      <div
        v-if="step == 'HORARIO'"
        :class="['tab-pane fade', step == 'HORARIO' && 'show active']"
        id="horario"
        role="tabpanel"
        aria-labelledby="nav-horario"
      >
        <div class="contracts-modern">
          <div class="contracts-header">
            <div class="header-content">
              <div class="title-section">
                <h2 class="section-title">
                  <i class="fas fa-clock title-icon"></i>

                  Horários
                </h2>

                <p class="section-subtitle">Verifique cuidados do Residente</p>
              </div>
            </div>
          </div>

          <div class="contract-content">
            <div class="info-card">
              <CareTime />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CareView from "../../templates/Resident/Care/CareView";

import CareTime from "../../templates/Resident/Care/CareTime";

import CareCreated from "../../templates/Resident/Care/CareCreated";

import { formatDate } from "../../lib/format";

import permission from "../../lib/permission";

import routes from "../../routes";

export default {
  name: "MenuCare",

  components: {
    CareCreated,
    CareView,
    CareTime,
  },

  props: {
    resident_id: Number,
  },

  data() {
    return {
      loading: false,

      step: "PRESCRICAO",

      group_prescription_medicines: [],

      total: 0,
    };
  },

  methods: {
    formatDate,
    permission,

    refresh() {
      this.$refs.careView.paginate();
    },

    handleStep(step) {
      let newNav;

      if (step == "PRESCRICAO") {
        newNav = "prescription";
      }

      if (step == "HORARIO") {
        newNav = "horario";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
  },
};
</script>

<style scoped>
.info-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.contracts-modern {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Header Section */
.contracts-header {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.title-section {
  flex: 1;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
  font-size: 20px;
}

.section-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 14px;
}

.actions-section {
  display: flex;
  gap: 12px;
}

/* Buttons */
.btn-add-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.btn-create-first {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
  margin-top: 16px !important;
}

.btn-create-first:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

/* Content Section */
.contracts-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Table Section */
.table-section {
  margin-bottom: 0;
}

.table-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.loading-overlay {
  border-radius: 16px;
  min-height: 200px;
}

/* No Results State */
.no-results {
  text-align: center;
  padding: 60px 24px;
}

.no-results-icon {
  font-size: 64px;
  color: #cbd5e1;
  margin-bottom: 20px;
}

.no-results-title {
  color: #1e293b;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.no-results-text {
  color: #64748b;
  font-size: 16px;
  margin: 0;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

/* Table Cell Styling */
.status-cell {
  display: flex;
  align-items: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  gap: 4px;
}

.status-active {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.status-inactive {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

.status-icon {
  font-size: 10px;
}

/* User Cell */
.user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.user-info {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: 500;
  color: #1e293b;
  font-size: 14px;
}

/* Contract Name Cell */
.contract-name-cell {
  max-width: 300px;
}

.contract-name {
  font-weight: 500;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: help;
  display: block;
}

/* Actions Cell */
.actions-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
}

.view-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  color: white !important;
  border: none !important;
}

.view-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4) !important;
}

/* Table Styling */
.modern-table {
  background: transparent !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .contracts-header {
    padding: 20px 16px;
  }

  .header-content {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .section-title {
    font-size: 20px;
    justify-content: center;
  }

  .section-subtitle {
    text-align: center;
  }

  .actions-section {
    justify-content: center;
  }

  .user-cell {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .user-avatar {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }

  .actions-cell {
    flex-direction: column;
    gap: 4px;
  }

  .no-results {
    padding: 40px 16px;
  }

  .no-results-icon {
    font-size: 48px;
  }

  .no-results-title {
    font-size: 18px;
  }

  .no-results-text {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 18px;
    flex-direction: column;
    gap: 8px;
  }

  .title-icon {
    font-size: 18px;
  }

  .btn-add-modern,
  .btn-create-first {
    padding: 10px 16px !important;
    font-size: 14px !important;
  }

  .status-badge {
    font-size: 10px;
    padding: 4px 8px;
  }

  .contract-name-cell {
    max-width: 200px;
  }
}

/* Override Vuetify styles */
.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table >>> .v-data-table thead th {
  background-color: #f8fafc !important;
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #e5e7eb !important;
  padding: 16px !important;
}

.modern-table >>> .v-data-table tbody tr {
  transition: all 0.2s ease !important;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}

.modern-table >>> .v-data-table tbody td {
  padding: 16px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}
</style>